"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.OtcRedirectionInteractionType=void 0;var i;(function(e){e.ContinueClicked="ContinueClicked",e.GoBackClicked="GoBackClicked"})(i||(exports.OtcRedirectionInteractionType=i={}));
//# sourceMappingURL=OtcRedirectionInteractionType.js.map
